import { Box, useTheme } from "@mui/material";
import { Location, Route, Routes } from "react-router-dom";
import { routes } from "../../routes";
import RouteWatcher from "./RouteWatcher";

interface AppRoutesProps {
  handlePathChange?: (location: Location) => void;
}
const AppRoutes = ({ handlePathChange }: AppRoutesProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: `calc(100dvh - ${theme.custom.appHeaderHeight} - ${theme.custom.appFooterHeight})`,
      }}
    >
      <RouteWatcher handlePathChange={handlePathChange} />
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            Component={route.Component}
            children={
              Array.isArray(route.children) &&
              route.children.map((child, childIndex) => (
                <Route
                  key={childIndex}
                  path={child.path}
                  element={child.element}
                />
              ))
            }
          />
        ))}
      </Routes>
    </Box>
  );
};

export default AppRoutes;
